import { Injectable } from '@angular/core';
import { Device } from '@awesome-cordova-plugins/device/ngx';
import { AppVersion } from '@awesome-cordova-plugins/app-version/ngx';
import { ModalController, Platform } from '@ionic/angular';
import { DeviceSupportComponent } from 'src/app/shared/components/device-support/device-support.component';

/**
 * Provides device and application info.
 */
@Injectable({
  providedIn: 'root',
})
export class DeviceApp {
  /** Class members */
  private info: any;

  constructor(
    private device: Device,
    private app: AppVersion,
    private platform: Platform,
    private modalCtrl: ModalController,
  ) {}

  getInfo(): Promise<any> {
    if (this.info) {
      return Promise.resolve(this.info);
    }

    this.info = {
      model: this.device.model,
      platform: this.device.platform,
      uuid: this.device.uuid,
      version: this.device.version,
      manufacturer: this.device.manufacturer,
      serial: this.device.serial,
    };

    if (!this.platform.is('cordova')) {
      return Promise.resolve(this.info);
    }
    return this.app.getVersionNumber().then((versionNumber) => {
      this.info.app = { version_number: versionNumber };

      // adding new field app_version. Keeping old field
      // for backward compatability
      this.info.app_version = versionNumber;

      return this.info;
    });
  }

  getVersion(): Promise<string> {
    return this.getInfo().then((data) => (data.app ? data.app.version_number : ''));
  }

  /**
   * Renders android minimum SDK version support message.
   */
  showSDKSupportMessage(): void {
    if (this.platform.is('cordova') && this.platform.is('android') && Number(this.device.sdkVersion) < 24) {
      this.modalCtrl
        .create({
          component: DeviceSupportComponent,
          cssClass: 'fullpage-modal',
        })
        .then((modal) => {
          // https://github.com/ionic-team/ionic-framework/issues/26872
          modal.shadowRoot.querySelector('.modal-wrapper').removeAttribute('aria-modal');

          modal.present();
        });
    }
  }
}
